<template>
  <b-modal
    hide-footer
    style="z-index: 99999"
    id="packed"
    size="lg"
    title="Packed an order"
  >
    <div v-if="selectedOrder != null && selectedOrder.order">
      <h3 class="my-4">Mark this order as Packed?</h3>
      <vs-row class="mt-5" vs-w="12">
        <vs-col vs-justify="center" vs-align="center" vs-w="5">
          <vs-button
            class="mt-5"
            style="width: 100%"
            @click="onAction('packed')"
            >Packed</vs-button
          >
        </vs-col>
        <vs-col vs-justify="center" vs-align="center" vs-w="2"></vs-col>
        <vs-col vs-justify="center" vs-align="center" vs-w="5">
          <vs-button
            class="mt-5"
            style="width: 100%"
            color="dark"
            @click="$emit('close')"
            >Cancel</vs-button
          >
        </vs-col>
      </vs-row>
    </div>
  </b-modal>
</template>
<script>
import Service from "@/services";

export default {
  components: {},
  name: "packed-dialog",
  props: {
    order: null
  },
  computed: {
    selectedOrder: {
      get() {
        return this.order;
      },
      set() {}
    }
  },
  methods: {
    onAction(type) {
      let data = {
        e: this.$route.query.e,
        order_id: this.selectedOrder.order.order_id,
        action: type,
        remark: ""
      };

      Service.Order.action(data)
        .then(() => {
          this.$vs.notify({
            title: "Success",
            text: "Update complete.",
            color: "success"
          });

          this.$emit("close");
        })
        .catch(err => {
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Oops!",
            text: "ERROR : " + err.error,
            color: "danger"
          });
        });
    }
  }
};
</script>
